var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.36981 10.4515C1.36981 15.0348 5.11988 18.7848 9.70314 18.7848C14.2864 18.7848 18.0365 15.0348 18.0365 10.4515C18.0365 5.86823 14.2864 2.11816 9.70314 2.11816M1.36981 10.4515C1.36981 5.86823 5.11988 2.11816 9.70314 2.11816M1.36981 10.4515L4.51642 10.4515M9.70314 2.11816L9.70315 5.26477M4.51642 10.4515C4.51642 13.3113 6.84336 15.6382 9.70315 15.6382C12.5629 15.6382 14.8899 13.3113 14.8899 10.4515C14.8899 7.59171 12.5629 5.26477 9.70315 5.26477M4.51642 10.4515C4.51642 7.59171 6.84336 5.26477 9.70315 5.26477M13.3689 14.1173L15.5712 16.3196M7.62846 8.89546V7.85811M7.62846 10.9701V9.9328M7.62846 13.0448V12.0075M9.18447 8.37678H12.2965M9.18447 10.4515H12.2965M9.18447 12.5262H12.2965",
    stroke: "#706F7B",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllocationIcon);
export default __webpack_public_path__ + "static/media/allocationIcon.71334c9e7f00d1ef90f6d1cbba018d02.svg";
export { ForwardRef as ReactComponent };